import { useRemoteClientPost } from '@/configs/http-client';
import { Endpoints } from '@/remote/endpoints';
import { useLocalStorage } from '@/remote/local-storage';
import { PaginationDemo } from '@/view/components/pagination';
import { TableUnits } from '@/view/components/table-units';
import { usePagination } from '@/view/hooks';
import { usePromiseToast } from '@/view/hooks/toast-promisse';
import { UnitsFormData } from '@/view/validators/units-validator';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function DisplayUnits() {
  const { httpClientPost } = useRemoteClientPost()
  const { triggerToast } = usePromiseToast()
  const { backPage, nextPage } = usePagination()
  const { getUnitId, isProfileAdmin } = useLocalStorage()
  const [params] = useSearchParams()
  const [data, setData] = useState<UnitsFormData[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    total: 0,
    totalPages: 0
  })

  const ITEMS_PER_PAGE = 10

  const updatePageInfo = (responseData: any) => {
    const content = responseData?.content ?? []
    const page = responseData?.pageable?.pageNumber ?? 0
    const totalPages = responseData?.totalPages ?? 0
    const total = responseData?.totalElements ?? 0

    setData(content)
    setPageInfo({
      page,
      total,
      totalPages
    })
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)

      const response = await httpClientPost(`${Endpoints.units}/filtro?page=${pageInfo.page}&size=${ITEMS_PER_PAGE}&order=desc&sort=id`, {
        idUnidade: isProfileAdmin() ? null : (params.get('id') ?? getUnitId()),
      });


      updatePageInfo(response?.data?.data)
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  const handlePageNavigation = (newPage: number) => {
    if (newPage >= 0 && newPage < pageInfo.totalPages) {
      setPageInfo(prev => ({ ...prev, page: newPage }))
    }
  }

  const handleNextPage = () => {
    nextPage(pageInfo.page, pageInfo.totalPages, (newPage) => {
      handlePageNavigation(newPage)
    })
  }

  const handlePreviousPage = () => {
    backPage(pageInfo.page, (newPage) => {
      handlePageNavigation(newPage)
    })
  }

  const handleRefresh = () => {
    triggerToast(fetchData())
  }

  useEffect(() => {
    handleRefresh()
  }, [pageInfo.page, params])

  return (
    <div className="space-y-4">
      {isLoading ? (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
        </div>
      ) : (
        <>
          <TableUnits
            data={data}
            getRefreshList={handleRefresh}
            height='280px'
          />

          {data.length > 0 && (
            <PaginationDemo
              totalForPage={ITEMS_PER_PAGE}
              back={handlePreviousPage}
              next={handleNextPage}
              page={pageInfo.page}
              total={pageInfo.total}
              labelItem='unidades'
            />
          )}
        </>
      )}
    </div>
  )
}